module.exports = __webpack_public_path__ + "static/media/6.0f8264b7.png";